<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadEventos()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-garagem_sol">Eventos</label>
          <multiselect
            id="selecao-evento-tele"
            v-model="value_eventos"
            required
            :options="eventos"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o(s) evento(s)"
            label="evento"
            track-by="evento"
            name="evento"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Evento selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data inicial</label>
            <b-form-datepicker
              id="dt_sol_inicial"
              required
              v-model="dt_inicial_operacao"
              placeholder="Data inicial "
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data final</label>
            <b-form-datepicker
              id="dt_sol_final"
              required
              v-model="dt_final_operacao"
              @input="loadScoreEventosResumo()"
              placeholder="Data do final"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1" class="mb-2">
          <label for="input-live">RE selecioando</label>
          <b-form-input
            v-model="pontosevento.re_operador"
            readonly
            placeholder="ND"
          ></b-form-input>
        </b-col>

        <LoadingModal v-if="isLoading" />
      </b-row>
      <p class="mt-2"></p>
    </b-form>

    <b-row>
      <b-col cols="3">
        <!--tbl de dados -->
        <!--tbl de dados -->

        <b-table
          id="PontosResumo"
          class="kontrow"
          small
          hover
          striped
          sticky-header="980px"
          :items="pontoseventos"
          :fields="fieldsKontrow"
        >
          <template slot="cell(actions)" slot-scope="data">
            <b-button
              @click="
                loadCarregaPontoOperador(data.item), loadScoreEventosOperador()
              "
              title="Eventos análiticos"
              size="sm"
              variant="primary"
              class="mr-2 mt-2"
              v-b-modal.modal-multi-1
            >
              <i class="fa fa-exclamation-circle"></i>
            </b-button>

            <b-button
              @click="postNotificacao(data.item.registro)"
              :title="'Eventos Notificações - ' + data.item.registro"
              size="sm"
              variant="warning"
              class="mr-2 mt-2"
            >
              <i class="fa fa-comment"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>

      <b-col cols="9">
        <b-table
          id="PontosAnalitico"
          small
          hover
          striped
          sticky-header="980px"
          :items="pontoseventosanaliticos"
          :fields="fieldsKontrowAnalitico"
        >
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "KontrowMonitoramento",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      valores = this.pontoseventos.filter((item) => {
        const registro = item.re_operador || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro

        return registro.indexOf(this.search) > -1;
      });
      return valores;
    },
  },

  data: function () {
    return {
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      value_empresa: [], // [this.empresas],
      value_eventos: [],
      dt_inicial_operacao: "",
      dt_final_operacao: "",
      eventos: [],
      pontoseventos: [],
      pontosevento: {},
      pontoseventosanaliticos: [],
      search: "",

      fieldsKontrow: [
        { key: "qtd_eventos", label: "Pontos", sortable: true },
        { key: "registro", label: "Operador", sortable: true },
        { key: "actions", label: "Análitico" },
        { key: "actions", label: "Notificações" },
      ],

      fieldsKontrowAnalitico: [
        {
          key: "dtevento",
          label: "Data da operação",
          sortable: true,
          formatter: (value, key, pontoseventosanaliticos) => {
            return moment(pontoseventosanaliticos.dtevento)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        { key: "prefixo", label: "Carro", sortable: true },
        { key: "linha", label: "Linha", sortable: true },
        { key: "evento_id", label: "Kontrow id", sortable: true },
        { key: "evento", label: "Evento", sortable: true },
        {
          key: "dt_eventohr",
          label: "Hora do evento",
          sortable: true,
          formatter: (value, key, pontoseventosanaliticos) => {
            return moment(pontoseventosanaliticos.dt_eventohr)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
      ],
    };
  },

  components: { LoadingModal, Multiselect },
  methods: {
    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadEventos() {
      let params = {
        empresa_id: `${this.empresas.map((e) => e.id_empresa)}`,
        psg: this.user.psg,
        app: true,
      };
      const url = `${baseApiUrl}/integracoes/kontrow/eventos`;
      axios.get(url, { params }).then((res) => {
        this.eventos = res.data.map((ev) => {
          return { evento_id: ev.evento_id, evento: ev.evento };
        });
      });
    },

    loadScoreEventosResumo() {
      this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/integracoes/kontrow/score`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pontoseventos = res.data;
          this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch(showError);
    },

    loadScoreEventosOperador() {
      this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        registro: `${[this.pontosevento.registro]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
      };
      const url = `${baseApiUrl}/integracoes/kontrow/operador`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pontoseventosanaliticos = res.data;
          // Após a conclusão da pesquisa
          this.isLoading = false; // Desative o indicador de carregamento
        })

        .catch(showError);
    },

    postNotificacao(RE) {
      this.isLoading = true; // Ative o indicador de carregamento
      const corpo = {
        psg: this.user.psg,
        app: true,
        registros: this.pontoseventos.map((item) => item.registro),
        origem: "ML18",
        envio: "GRUPO",
        empresa_id: this.value_empresa.map((e) => e.id_empresa)[0],
        titulo_id: 6,
        origem_id: 3,
        status_id: 1,
        funcionario_cad_id: this.user.id_funcionario,
        descricao: `Novos eventos da telemetria do período de ${moment(
          this.dt_inicial_operacao
        ).format("DD/MM/YYYY")} até ${moment(this.dt_final_operacao).format(
          "DD/MM/YYYY"
        )}`,
      };

      axios
        .post(`${baseApiUrl}/sac/solicitacoes/notificacoes`, corpo)
        .then((res) => {
          this.isLoading = false;
          this.pontoseventosanaliticos = res.data;
        })
        .catch(showError);

      /*
      let corpo = {
        psg: this.user.psg,
        app: true,
        registro: RE,
        origem: "ML18",
        empresa: "KONTROW",
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        titulo_id: 3,
        origem_id: 6,
        status_id: 1,
        funcionario_cad_id: this.user.id_funcionario,
        descricao: `Novos eventos da telemetria do período de ${moment(
          this.dt_inicial_operacao
        ).format("DD/MM/YYYY")} até ${moment(this.dt_final_operacao).format(
          "DD/MM/YYYY"
        )}`,
      };
      const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.pontoseventosanaliticos = res.data;
          // Após a conclusão da pesquisa
          this.isLoading = false; // Desative o indicador de carregamento
        })

        .catch(showError);]
        */
    },

    loadCarregaPontoOperador(pontosevento) {
      this.pontosevento = { ...pontosevento };
    },

    gerarPlanilha() {
      // Objeto com os dados para a planilha
      const dados = this.pedidoferias;

      // Cria uma nova planilha
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(dados);

      // Adiciona a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

      // Salva o workbook como arquivo
      XLSX.writeFile(workbook, "pedido_de_ferias.xlsx");
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadCarregaPontoOperador();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>